import React, { useState, useEffect } from 'react';
import { ControlledAccordions } from './ControlledAccordions';
import { Page } from './Page';
import { Box } from '@mui/system';

const postsPerPage = 10

export const AccordionPage = ({ fetchData, load }: any) => {
  const [loading, setLoading] = useState(false)
  const [posts, setPosts] = useState<any>([])
  const [currentPage, setCurrentPage] = useState<number>(1)
  useEffect(() => {
    setLoading(true)
    if (fetchData.length !== 0) {
      setLoading(true)
      setPosts(fetchData.data)
      setLoading(false)
    }
    else {
      setLoading(true)
    }
  }, [fetchData])

  const indexOfLastPost = currentPage * postsPerPage;
  const indexOfFirstPost = indexOfLastPost - postsPerPage;
  const currentPosts = posts.slice(indexOfFirstPost, indexOfLastPost)
  const paginate = (pageNumber: any) => setCurrentPage(pageNumber);
  return (
    <Box >
      <ControlledAccordions posts={currentPosts} loading={loading} />
      <Page
        postsPerPage={postsPerPage}
        totalPosts={posts.length}
        paginate={paginate}
      />
    </Box>

  );
};
